/**************************************************
 * Nombre:       Seccion_Inicio
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tarjeta_Deposito from "../Tarjetas_Especiales/Tarjeta_Deposito";
import Tarjeta_Activos from "../Tarjetas_Especiales/Tarjeta_Activos";
import Tarjeta_Ganancias from "../Tarjetas_Especiales/Tarjeta_Ganancias";
import Tarjeta_Membresia from "../Tarjetas_Especiales/Tarjeta_Membresia";
import Tarjeta_Rendimientos from "../Tarjetas_Especiales/Tarjeta_Rendimientos";
import Tarjeta_Bonos from "../Tarjetas_Especiales/Tarjeta_Bonos";
import Tarjeta_Plan_Carrera from "../Tarjetas_Especiales/Tarjeta_Plan_Carrera";
import {useEffect} from "react";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Dashboard = () => {

    useEffect(() => {
        irArriba()
    },[])
    return (
        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', color: 'white', pb: 10, pt: 8}}
                spacing={4}
            >

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Ganancias/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Membresia/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Deposito/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Activos/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Rendimientos/>
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 5}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Bonos/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Plan_Carrera/>
                </Grid>



            </Grid>
        </Grid>
    )

}
export default Seccion_Dashboard